import React from "react";
import Button from "@insightfulscience/atomic-react/Button";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import useTracking, { CATCH } from "@insightfulscience/smart-react/useTracking";
import SmartForm from "@insightfulscience/smart-react/SmartForm";
import NextLink from "@insightfulscience/smart-react/NextLink";
import { AuthContainerTitle } from "@insightfulscience/atomic-react/r1/molecules/AuthContainer";
import { useLocale } from "@insightfulscience/i18";
import Block from "@insightfulscience/atomic-react/Block";
import useResultStatus from "../utils/useResultStatus";
import routes from "../routes";
import login from "./action";
import { initialState, validateForm } from "./form";

function LoginForm() {
	const [t] = useLocale("login-form");
	const [loginAction, isSigningIn] = useTracking(login, CATCH);
	const [action, { errors }, resetResult] = useResultStatus(loginAction);

	return (
		<>
			{isSigningIn && <Spinner />}
			<AuthContainerTitle id="equalHeightSource" data-qa-selector="signIn-form-title">
				{t("FORM_TITLE")}
			</AuthContainerTitle>
			<SmartForm textRender={t} {...{ initialState, validateForm, action }} onTouched={resetResult}>
				<SmartForm.Field
					label="EMAIL"
					name="email"
					type="email"
					disabled={isSigningIn}
					error={errors.localeMessage}
					fieldClassName="mb-8"
					maxLength={100}
					required
					data-qa-selector="signIn-email-input"
				/>

				<SmartForm.Field
					label="PASSWORD"
					name="password"
					type="password"
					disabled={isSigningIn}
					error={errors.localeMessage}
					fieldClassName="mb-8"
					maxLength={65}
					required
					data-qa-selector="signIn-password-input"
					link={
						<NextLink size="s" href={routes.forgotPassword} data-qa-selector="signIn-forgot-link">
							{t("FORGOT_PASSWORD")}
						</NextLink>
					}
				/>

				<Row>
					<Col spacing={{ mt: 4, mb: 2 }}>
						<Block sx={{ textAlign: "center" }}>
							<Button type="submit" disabled={isSigningIn} data-qa-selector="signIn-submit-button">
								{t("SIGN_IN")}
							</Button>
						</Block>
					</Col>
				</Row>
			</SmartForm>
		</>
	);
}

export default LoginForm;
